/**
 * User-provided marketing hero photos (site owner licensed).
 * Served from frontend/public/marketing/hero/.
 *
 * Carousel leads with Griffey, then NBA and NFL stills, then the remaining MLB shots.
 */
export const marketingHeroPhotos = [
  {
    sport: "mlb",
    src: "/marketing/hero/ken-griffey-swing.webp",
    alt: "Ken Griffey Jr. mid-swing in a Seattle Mariners road uniform",
    objectPosition: "45% center",
    caption: "Ken Griffey Jr. · MLB",
  },
  {
    sport: "nba",
    src: "/marketing/hero/steph-curry-warriors.webp",
    alt: "Stephen Curry celebrating in a Golden State Warriors jersey",
    objectPosition: "58% 28%",
    caption: "Stephen Curry · NBA",
  },
  {
    sport: "nfl",
    src: "/marketing/hero/jim-brown-browns.webp",
    alt: "Jim Brown running for the Cleveland Browns as a Packers defender dives",
    objectPosition: "48% 40%",
    caption: "Jim Brown · NFL",
  },
  {
    sport: "mlb",
    src: "/marketing/hero/albert-pujols-cardinals.webp",
    alt: "Albert Pujols batting for the St. Louis Cardinals",
    objectPosition: "center 40%",
    caption: "Albert Pujols · MLB",
  },
  {
    sport: "mlb",
    src: "/marketing/hero/shohei-ohtani-batting.webp",
    alt: "Shohei Ohtani at bat during an MLB game",
    objectPosition: "center 35%",
    caption: "Shohei Ohtani · MLB",
  },
];

const LEAGUE_PHOTO_SPORTS = ["nba", "nfl", "mlb"];

/** One still per league for the static three-up panel. Pages may pass different items. */
export const defaultLeaguePhotos = LEAGUE_PHOTO_SPORTS.flatMap((sport) => {
  const photo = marketingHeroPhotos.find((entry) => entry.sport === sport);
  return photo ? [photo] : [];
});

/**
 * About-page three-up stills (site owner licensed).
 * Served from frontend/public/marketing/about/. Same NBA → NFL → MLB order as the home panel.
 */
export const aboutLeaguePhotos = [
  {
    sport: "nba",
    src: "/marketing/about/michael-jordan-dunk.webp",
    alt: "Michael Jordan dunking in a Chicago Bulls No. 23 jersey",
    objectPosition: "52% 28%",
    caption: "Michael Jordan · NBA",
  },
  {
    sport: "nfl",
    src: "/marketing/about/aaron-rodgers-packers.webp",
    alt: "Aaron Rodgers throwing for the Green Bay Packers against the Chicago Bears",
    objectPosition: "72% 32%",
    caption: "Aaron Rodgers · NFL",
  },
  {
    sport: "mlb",
    src: "/marketing/about/babe-ruth-swing.webp",
    alt: "Babe Ruth batting in a black-and-white photograph",
    objectPosition: "68% 38%",
    caption: "Babe Ruth · MLB",
  },
];

/** Crossfade interval when motion is allowed (ms). */
export const heroCarouselIntervalMs = 8000;

/** Opacity transition duration (ms). */
export const heroCarouselFadeMs = 1800;
